<template>
  <div id="simple-editor" class="simple-editor"></div>
</template>

<script>
import "./simple-editor.css";
// upload
import { uploadFile } from "@/plugins/uploadFile";
import { loadScript } from "@/plugins/util";
// element-ui
import { Message } from "element-ui";

export default {
  name: "simple-editor",
  props: {
    editorData: {
      type: [Array, String]
    },
    imageStyle: {
      type: Object,
      default: () => ({})
    },
    hideEditorBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null,
      // 1本地上传,右下角水印，2全身加水印上传
      uploadType: 1
    };
  },
  watch: {
    hideEditorBtn(val) {
      this.importEditorPlugin();
    }
  },
  mounted() {
    // console.log(1, this.editorData);
    this.importEditorPlugin();
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
  methods: {
    importEditorPlugin() {
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/simple-editor.umd.js?t=10000`).then(() => {
        const simpleEditor = window.simpleEditor;
        this.initEditor(simpleEditor);
      });
    },
    initContent(content) {
      const defaultContent = [
        {
          type: "paragraph",
          children: [
            {
              text: ""
            }
          ]
        }
      ];
      if (typeof content === "string") {
        defaultContent[0].children[0].text = content;
        return defaultContent;
      } else if (Array.isArray(content)) {
        const firstContent = content[0];
        if (firstContent && Array.isArray(firstContent.children)) {
          const firstText = firstContent.children[0];
          if (firstText) {
            return JSON.parse(JSON.stringify(content));
          } else {
            return defaultContent;
          }
        } else {
          return defaultContent;
        }
      } else {
        return defaultContent;
      }
    },
    formatContent(conetent = [], level = 0) {
      let formatContent = [];
      conetent.forEach(item => {
        let itemTemp = item;
        // 第一层必须为一行段落
        if (level === 0) {
          if (!item.type || !item.children || !Array.isArray(item.children)) {
            itemTemp = {
              type: "paragraph",
              children: [{ text: "" }]
            };
          }
        }
        if (itemTemp.type) {
          // 类型节点
          if (itemTemp.children && Array.isArray(itemTemp.children)) {
            const children = this.formatContent(itemTemp.children, level + 1);
            formatContent.push({
              ...itemTemp,
              children
            });
          } else {
            formatContent.push({
              ...itemTemp,
              children: [{ text: "" }]
            });
          }
        } else {
          // 文本节点
          // eslint-disable-next-line
          if (itemTemp.hasOwnProperty("text")) {
            formatContent.push(itemTemp);
          } else {
            formatContent.push({ text: "" });
          }
        }
      });
      return formatContent;
    },
    initEditor(simpleEditor) {
      const { createEditor } = simpleEditor;
      // console.log(this.editorData);
      const content = this.formatContent(this.initContent(this.editorData));
      // console.log(content);
      const editor = createEditor({
        selector: "#simple-editor",
        content,
        config: {
          autoFocus: true,
          hideToolbar: false,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          toolbarKeys: [
            "bold",
            "underline",
            "italic",
            "through",
            "clearStyle",
            "|",
            "insertLink",
            !this.hideEditorBtn ? "insertButton" : "",
            "|",
            "uploadImage",
            "color",
            "bgColor",
            "|",
            "fontSize",
            "lineHeight"
          ].filter(it => !!it),
          MENU_CONF: {
            // 图片上传配置
            uploadImage: {
              base64LimitSize: 1000,
              customUpload: this.customUploadImage
            },
            button: {
              options: [
                {
                  value: "RICH_TEXT_DIALOG",
                  name: "二级弹窗"
                },
                {
                  value: "RICH_TEXT_POPOVER",
                  name: "注释说明"
                }
              ],
              customExec: this.customExecButton
            }
          }
        }
      });
      this.editor = Object.seal(editor);
    },
    onChange(editor) {
      // console.log("editor onChange");
      const editorData = editor.children;
      this.$emit("onChange", editorData);
    },
    onBlur() {
      this.$emit("onBlur");
    },
    onFocus() {
      // console.log("editor onFocus");
      this.$emit("onFocus");
    },
    async customUploadImage(file, insertFn) {
      try {
        let params = {
          file: file,
          width: 0,
          height: 0,
          url: "",
          localImgUrl: "",
          percent: 0,
          text: "",
          waterMark: this.uploadType,
          isDelete: false,
          progressCb: percent => {
            params.percent = percent;
          }
        };
        // console.log(params);
        const res = await uploadFile(params);
        // console.log(res);
        const url = res.url;
        const alt = "";
        const href = "";
        const { width = "auto", height = "auto" } = this.imageStyle;
        const style = { width, height };

        // 自己实现上传，并得到图片 url alt href
        // 最后插入图片
        insertFn(url, alt, href, style);
      } catch (error) {
        Message({
          message: "图片上传错误！",
          type: "error"
        });
        console.log(error);
      }
    },
    async beforeUploadImage() {
      // console.log("beforeUploadImage");
      return new Promise((resolve, reject) => {
        this.$confirm(
          `
          <div class="image-input-form">
            <div style="margin-bottom: 20px;">
              <label for="imgWidth">宽度(px)：</label><input type="number" id="_imgWidth" />
            </div>
            <div style="margin-bottom: 20px;">
              <label for="imgWidth">高度(px)：</label><input type="text" id="_imgHeight" />
            </div>
          </div>
          `,
          "设置上传图片全局尺寸",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "alert"
          }
        )
          .then(() => {
            const width = document.getElementById("_imgWidth").value + "px";
            const height = document.getElementById("_imgHeight").value + "px";
            const data = { width, height };
            sessionStorage.setItem("__pageGlobalImageSize__", JSON.stringify(data));
            Message({
              message: "设置完成，请再次上传图片！",
              type: "success"
            });
          })
          .catch(() => {
            reject();
          });
      });
    },
    async customExecButton(key, id, data) {
      this.$emit("onButtonExec", key, id, data);
    }
  }
};
</script>

<style lang="less">
.simple-editor {
  position: relative;
  z-index: 100;
  width: 100%;
  // min-width: 80px;
  min-height: 100%;
  border-radius: inherit;
  background: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

.s-e-container {
  border-radius: 4px;
}
.s-e-scroll {
  overflow: initial;
}

.image-input-form {
  width: 100%;
  line-height: 30px;
  label {
    font-size: 14px;
    color: #333;
  }
  input {
    width: 300px;
    height: 30px;
    border: 1px solid #666;
    padding: 0 8px;
    border-radius: 4px;
  }
}
</style>
